import React, { Suspense, lazy } from "react";
import { Navigate, Route, useParams } from "react-router-dom";
import { RequirePortalAuth } from "../pages/Login";
import { PortalPageFallback } from "../components/PortalLoader";
import NaturalsControlLayout from "./NaturalsControlLayout";
import { ENTERPRISE_CONTROL_BASE } from "./constants";

const Fallback = () => <PortalPageFallback message="Loading page" />;

const EnterpriseDashboardPage = lazy(() => import("./pages/NaturalsDashboardPage"));
const EnterpriseOrganizationsPage = lazy(() => import("./pages/NaturalsOrganizationsPage"));
const EnterpriseOrganizationDetailPage = lazy(() => import("./pages/NaturalsOrganizationDetailPage"));
const EnterpriseLicensesHubPage = lazy(() => import("./pages/NaturalsLicensesHubPage"));
const EnterpriseAuditPage = lazy(() => import("./pages/NaturalsAuditPage"));

const PORTAL_HOME = "/enterprise-portal/home";
const PORTAL_ORG_EDIT_BASE = "/enterprise-portal/organizations";

function LegacyOrgDetailRedirect() {
  const { orgId } = useParams();
  return <Navigate to={`${ENTERPRISE_CONTROL_BASE}/organizations/${orgId}`} replace />;
}

function ManageToOrgRedirect() {
  const { orgId } = useParams();
  return <Navigate to={`${ENTERPRISE_CONTROL_BASE}/organizations/${orgId}`} replace />;
}

function EnterpriseControlCreateRedirect() {
  return <Navigate to={PORTAL_HOME} replace />;
}

function EnterpriseControlEditRedirect() {
  const { orgId } = useParams();
  return <Navigate to={`${PORTAL_ORG_EDIT_BASE}/${orgId}/edit`} replace />;
}

export function renderEnterpriseControlRoutes() {
  return (
    <Route
      path={ENTERPRISE_CONTROL_BASE}
      element={
        <RequirePortalAuth>
          <NaturalsControlLayout />
        </RequirePortalAuth>
      }
    >
      <Route
        index
        element={
          <Suspense fallback={<Fallback />}>
            <EnterpriseDashboardPage />
          </Suspense>
        }
      />
      <Route
        path="organizations"
        element={
          <Suspense fallback={<Fallback />}>
            <EnterpriseOrganizationsPage />
          </Suspense>
        }
      />
      <Route
        path="organizations/:orgId"
        element={
          <Suspense fallback={<Fallback />}>
            <EnterpriseOrganizationDetailPage />
          </Suspense>
        }
      />
      <Route path="organizations/:orgId/manage" element={<ManageToOrgRedirect />} />
      <Route path="organizations/new" element={<EnterpriseControlCreateRedirect />} />
      <Route path="organizations/:orgId/edit" element={<EnterpriseControlEditRedirect />} />
      <Route
        path="licenses"
        element={
          <Suspense fallback={<Fallback />}>
            <EnterpriseLicensesHubPage />
          </Suspense>
        }
      />
      <Route
        path="audit"
        element={
          <Suspense fallback={<Fallback />}>
            <EnterpriseAuditPage />
          </Suspense>
        }
      />
      <Route path="*" element={<Navigate to={ENTERPRISE_CONTROL_BASE} replace />} />
    </Route>
  );
}

export { LegacyOrgDetailRedirect, ENTERPRISE_CONTROL_BASE };
